<template>
  <div>
    <button class="btn"
      :class = "color"
      @click.prevent="clickbutton">{{ msg }}</button>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default: '這是一個按鈕',
    },
    btncolor: {
      type: Array,
      default: () => ([
        'btn-primary',
      ]),
    },
  },
  methods: {
    clickbutton() {
      this.$emit('clickbutton');
    },
  },
  data() {
    return {
      color: this.btncolor,
    };
  },
};
// 使用方法：
// <Button :msg="button"></Button>
// data用 button: '發送訊息',
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
button {
  width: 100%;
  padding: 5px 30px;
  border-radius: 10px;
  font-size: 1rem;
}

// 以下是各button的樣式設計，如果要找當初設定他的地方，就去他的class name
// 每個botton都有加上hover-btn
.hover-btn:hover{
  opacity: 0.9;
}

// -----------------listPicture_area
.listPicture_area{
  background-color: #DD6439;
  color: #fff;
}

// -----------------quatercard_one
.quatercard_one {
  background-color: #DD6439;
  color: #fff;
  padding: 2px 30px;
}

// -----------------whoweare
.whoweare{
  background-color: #DD6439;
  color: #fff;
}

// -----------------member_text
.member_text{
  background-color: #009FB7;
  color: #fff;
}

// -----------------only_form
.only_form{
  background-color: #009FB7;
  color: #fff;
}

// -----------------contactus
.contactus {
  max-width: 150px;
}

</style>
